import React from 'react';
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";


export default class CustomerSuffix extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		disabledParts: PropTypes.bool,
		update: PropTypes.func.isRequired,
	};

	render() {
		/** @type {Customers_Object} object */
		let object = this.props.object;
		/** @type {Customers_Properties} properties*/
		let properties = this.props.properties;
		let disabledParts = this.props.disabledParts;

		return <Framework.Elements.Select
			label={"Suffix"}
			shouldLoad={object.loaded}
			update={this.props.update}
			objects={[
				{pkey: 'SR', name: 'Sr'},
				{pkey: 'JR', name: 'Jr'},
				{pkey: 'II', name: 'II'},
				{pkey: 'III', name: 'III'},
				{pkey: 'IV', name: 'IV'},
				{pkey: 'V', name: 'V'},
				{pkey: 'VI', name: 'VI'},
				{pkey: 'VII', name: 'VII'},
				{pkey: 'VIII', name: 'VIII'},
				{pkey: 'IX', name: 'IX'},
				{pkey: 'X', name: 'X'},
			]}
			property={properties.name_suffix}
			value={object.name_suffix}
			error={object.name_suffix_error}
			text={'name'}
			nullable={true}
			limit={null}
			disabled={!!disabledParts}
		/>

	}
}

